/* eslint-disable import/prefer-default-export */
import { createContext } from "react";

interface IPromisifiedDialogContext {
    setModal: (id: number, modal: React.ReactNode) => void;
    removeModal: (id: number) => void;
}

const PromisifiedDialogContext =
    createContext<IPromisifiedDialogContext | null>(null);

PromisifiedDialogContext.displayName = "PromisifiedDialogContext";

export { PromisifiedDialogContext };
